// extracted by mini-css-extract-plugin
module.exports = {"heading":"contact-module--heading--1dM6r","list":"contact-module--list--12_Em","item":"contact-module--item--ni_gd","faq":"contact-module--faq--2j_Kg"};